import { rest, RestHandler } from 'msw';
import {
  JAVA_EXCEPTION_ERROR,
  generatePaymentsBffUrl,
  POLLING_STATUS
} from 'adapters/constants';
import { vendorsTableData } from '../mockData/vendorsTableData';

export const testHandler: RestHandler[] = [
  rest.get(`${generatePaymentsBffUrl()}/test-api-no-async`, (_, res, ctx) =>
    res(ctx.status(200), ctx.json(vendorsTableData))
  ),
  rest.get(`${generatePaymentsBffUrl()}/test-api/async`, (_, res, ctx) =>
    res(ctx.status(200), ctx.json(12345))
  ),
  rest.get(
    `${generatePaymentsBffUrl()}/test-api/async/12345/status`,
    (_, res, ctx) =>
      res(
        ctx.status(200),
        ctx.json({
          status: POLLING_STATUS.COMPLETED,
          current: 1,
          total: 1
        })
      )
  ),
  rest.get(
    `${generatePaymentsBffUrl()}/test-api/async/12345/results`,
    (_, res, ctx) => res(ctx.status(200), ctx.json(vendorsTableData))
  ),
  rest.get(`${generatePaymentsBffUrl()}/test-api-error`, (_, res, ctx) =>
    res(
      ctx.status(401),
      ctx.json({
        errorMessage: 'unAuthorized'
      })
    )
  ),
  rest.get(`${generatePaymentsBffUrl()}/test-api-java-error`, (_, res, ctx) =>
    res(
      ctx.status(401),
      ctx.json({
        errorMessage: JAVA_EXCEPTION_ERROR
      })
    )
  ),
  rest.get(`${generatePaymentsBffUrl()}/test-api-error/async`, (_, res, ctx) =>
    res(ctx.status(200), ctx.json(12345))
  ),
  rest.get(
    `${generatePaymentsBffUrl()}/test-api-error/async/12345/status`,
    (_, res, ctx) =>
      res(
        ctx.status(200),
        ctx.json({
          status: POLLING_STATUS.COMPLETED,
          current: 1,
          total: 1
        })
      )
  ),
  rest.get(
    `${generatePaymentsBffUrl()}/test-api-error/async/12345/results`,
    (_, res, ctx) =>
      res(ctx.status(401), ctx.json({ errorMessage: 'unAuthorized' }))
  ),
  rest.get(
    `${generatePaymentsBffUrl()}/test-api-polling-error/async`,
    (_, res, ctx) => res(ctx.status(200), ctx.json(12345))
  ),
  rest.get(
    `${generatePaymentsBffUrl()}/test-api-polling-error/async/12345/status`,
    (_, res, ctx) =>
      res(
        ctx.status(200),
        ctx.json({
          status: POLLING_STATUS.ERROR,
          message: 'Error message from API'
        })
      )
  )
];
